exports.createServer =
exports.createConnection =
exports.connect =
function () {};

exports.isIP =
exports.isIPv4 =
exports.isIPv6 =
function () { return true };




//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/mock/net.js
// module id = 1910
// module chunks = 0